import { ValidatorFunction } from '../types';

type CompositionArg = [ValidatorFunction, ...ValidatorFunction[]];

export function and(...validators: CompositionArg): ValidatorFunction {
  return (value: any) => {
    for (const validator of validators) {
      const valid = validator(value);
      if (typeof valid === 'string') {
        return valid;
      }
    }

    return true;
  };
}

export function or(...validators: CompositionArg): ValidatorFunction {
  return (value: any) => {
    for (const validator of validators) {
      const valid = validator(value);
      if (valid === true) {
        return true;
      }
    }

    return validators[0](value);
  };
}
